/* JC-EVO 10/06/2026 (Eric: "when a new variant is chosen, the picture doesn't update to the new
   variant of the product"). The RKIN gallery (blocks/custom-product-media.liquid, .cpm) never listened
   for a variant change, so the photo stayed on the first image. Horizon's variant picker dispatches
   shopify:product:select (bubbling, from the picker) with detail.variantId immediately and a promise
   that resolves to the variant JSON Horizon already fetched for the price. This file only points the
   existing gallery at that variant's photo. No new request, no change to the gallery's look or the lightbox.
   Loaded once, deferred, by blocks/custom-product-media.liquid.
   JC-EVO 10/06/2026 fix 1: only the section's main variant-picker (data-template-product-match="true"
   in snippets/variant-main-picker.liquid, set when product.id == product_resource.id) may move the
   photo. After the picker's fetch resolves, the photo is applied again on the section that currently
   has that id.
   JC-EVO 10/06/2026 fix 2: match featured_media.id to data-media-id only. No filename fallback.
   JC-EVO 10/06/2026 fix 3: no stored gallery state. Every match updates the desktop gallery
   (main image, .is-active thumb, .cpm__dot). On screen that is the thumbnail click. While that
   gallery is display:none the same src and classes are set directly, because the click handler
   scrolls the thumb into view. The phone strip and its dots move only when the strip is visible.
   JC-EVO 10/06/2026 fix 4: the active desktop thumb owns rotation; settled phone swipes
   update that thumb with DOM writes. No saved selection or lightbox handlers. */
(function () {
  'use strict';
  if (window.jcCpmVariant) return;
  window.jcCpmVariant = true;

  var EVENT = 'shopify:product:select';
  /* Sticky bar, quick add, product cards, cart upsells, and bundle widgets can sit in the same
     section and can dispatch this event. They never own the hero gallery. */
  var REJECT = 'sticky-add-to-cart, quick-add-dialog, quick-add-component, quick-add-modal, product-card, .jc-cart-upsells, product-bundle, .bundle-products, [data-bundle-id], bundle-picker';
  var cache = {};
  var token = {};

  function pushUnique(list, value) {
    var i;
    for (i = 0; i < list.length; i++) if (list[i] === value) return;
    list.push(value);
  }

  function idHits(nodes, mediaId) {
    var hits = [];
    var i, img, id;
    for (i = 0; i < nodes.length; i++) {
      id = nodes[i].getAttribute('data-media-id') || '';
      img = nodes[i].querySelector('img');
      if (!id && img) id = img.getAttribute('data-media-id') || '';
      if (id && String(id) === String(mediaId)) pushUnique(hits, i);
    }
    return hits;
  }

  /* One thumb, or else one slide. Anything else is not a match. */
  function findIndex(cpm, mediaId) {
    var hits;
    if (!cpm || mediaId == null || mediaId === '') return -1;
    hits = idHits(cpm.querySelectorAll('.cpm__thumb'), mediaId);
    if (hits.length === 1) return hits[0];
    if (hits.length > 1) return -1;
    hits = idHits(cpm.querySelectorAll('.jc-pdp-slide'), mediaId);
    if (hits.length === 1) return hits[0];
    return -1;
  }

  /* featured_media.id is the Liquid media.id. featured_image.id is a different id and is ignored.
     A non-image featured_media (media_type present and not "image") changes nothing. This store's
     image JSON omits media_type; those still match by id. */
  function mediaIdOf(resource) {
    var media;
    if (!resource) return '';
    media = resource.featured_media;
    if (!media || media.id == null || media.id === '') return '';
    if (media.media_type && media.media_type !== 'image') return '';
    return String(media.id);
  }

  function rejected(el) {
    return !!(el && el.closest && el.closest(REJECT));
  }

  /* No fallback picker. The attribute is the RC7 marker for the template product's own picker. */
  function mainPicker(section) {
    var list = section.querySelectorAll('variant-picker');
    var i;
    for (i = 0; i < list.length; i++) {
      if (list[i].getAttribute('data-template-product-match') !== 'true') continue;
      if (rejected(list[i])) continue;
      return list[i];
    }
    return null;
  }

  function productIdOf(section) {
    var picker = mainPicker(section);
    return picker ? (picker.getAttribute('data-product-id') || '') : '';
  }

  function sectionKey(section) {
    return section.id || '';
  }

  function sectionNow(id) {
    var el;
    if (!id) return null;
    el = document.getElementById(id);
    if (!el) return null;
    if (el.classList && (el.classList.contains('shopify-section') || el.tagName === 'DIALOG')) return el;
    return el.closest ? el.closest('.shopify-section, dialog') : null;
  }

  function readSelected(section) {
    var picker = mainPicker(section);
    var script;
    if (!picker) return null;
    script = picker.querySelector('script[type="application/json"]');
    if (!script || !script.textContent) return null;
    try { return JSON.parse(script.textContent); } catch (e) { return null; }
  }

  function remember(section, resource) {
    if (!resource || resource.id == null) return;
    cache[productIdOf(section) + ':' + resource.id] = resource;
  }

  function lookup(section, variantId) {
    var hit, current;
    if (!variantId) return null;
    hit = cache[productIdOf(section) + ':' + variantId];
    if (hit) return hit;
    current = readSelected(section);
    if (current && String(current.id) === String(variantId)) return current;
    return null;
  }

  function galleriesIn(section) {
    var all = section.querySelectorAll('.cpm');
    var out = [];
    var i;
    for (i = 0; i < all.length; i++) {
      if (all[i].closest('product-card')) continue;
      if (!all[i].querySelector('.cpm__thumb')) continue;
      out.push(all[i]);
    }
    return out;
  }

  /* Active thumb/dot stay authoritative while hidden; image writes require desktop layout. */
  function forceThumb(cpm, thumb, index) {
    var main = cpm.querySelector('[data-main-image]');
    var src = thumb.getAttribute('data-full-src');
    var alt = thumb.getAttribute('data-alt') || '';
    var srcset = thumb.getAttribute('data-full-srcset');
    var thumbs, dots, i;
    if (main && src && !deskHidden(cpm)) {
      if (main.hasAttribute('srcset') && srcset) main.setAttribute('srcset', srcset);
      main.setAttribute('src', src);
      main.setAttribute('alt', alt);
    }
    thumbs = cpm.querySelectorAll('.cpm__thumb');
    for (i = 0; i < thumbs.length; i++) {
      if (thumbs[i].classList.contains('is-active') !== (i === index)) thumbs[i].classList.toggle('is-active', i === index);
    }
    dots = cpm.querySelectorAll('.cpm__dot');
    for (i = 0; i < dots.length; i++) {
      if (dots[i].classList.contains('is-active') !== (i === index)) dots[i].classList.toggle('is-active', i === index);
    }
  }

  function deskNeeds(cpm, index) {
    var thumb = cpm.querySelectorAll('.cpm__thumb')[index];
    var main, want, dots;
    if (!thumb || !thumb.classList.contains('is-active')) return true;
    main = cpm.querySelector('[data-main-image]');
    want = thumb.getAttribute('data-full-src') || '';
    if (main && want && (main.getAttribute('src') || '') !== want) return true;
    dots = cpm.querySelectorAll('.cpm__dot');
    if (dots.length && !(dots[index] && dots[index].classList.contains('is-active'))) return true;
    return false;
  }

  /* Like the strip, the desktop container needs width before image writes. Hidden selections
     only set classes; the native click can scrollIntoView at phone width. */
  function deskHidden(cpm) {
    var main = cpm.querySelector('.cpm__main') || cpm.querySelector('[data-main-image]');
    return !main || !main.clientWidth || !main.getClientRects || main.getClientRects().length === 0;
  }

  function applyDesk(cpm, index) {
    var thumb = cpm.querySelectorAll('.cpm__thumb')[index];
    if (!thumb) return;
    if (!deskHidden(cpm)) thumb.click();
    if (deskNeeds(cpm, index)) forceThumb(cpm, thumb, index);
  }

  function nodeMediaId(node) {
    var img;
    if (!node) return '';
    img = node.querySelector('img');
    return node.getAttribute('data-media-id') || (img && img.getAttribute('data-media-id')) || '';
  }

  function nodeSrc(node) {
    var img = node.querySelector('img');
    return node.getAttribute('data-full-src') || (img && img.getAttribute('src')) || '';
  }

  /* JC-EVO: IDs map reordered lists. Position needs equal counts and proven image order. */
  function mapIndex(from, to, index) {
    var id, hits, i, a, b, src;
    if (!from[index]) return -1;
    id = nodeMediaId(from[index]);
    if (id) {
      hits = idHits(to, id);
      if (hits.length > 1 || idHits(from, id).length > 1) return -1;
      if (hits.length === 1) return hits[0];
    }
    if (from.length !== to.length) return -1;
    for (i = 0; i < from.length; i++) {
      a = nodeMediaId(from[i]);
      b = nodeMediaId(to[i]);
      if (a && b) {
        if (a !== b || idHits(from, a).length !== 1 || idHits(to, b).length !== 1) return -1;
      } else {
        src = nodeSrc(from[i]);
        if (!src || src !== nodeSrc(to[i])) return -1;
      }
    }
    return index;
  }

  function activeThumbIndex(cpm) {
    var thumbs = cpm.querySelectorAll('.cpm__thumb');
    var index = -1;
    var i;
    for (i = 0; i < thumbs.length; i++) {
      if (!thumbs[i].classList.contains('is-active')) continue;
      if (index !== -1) return -1;
      index = i;
    }
    return index;
  }

  /* Desktop entry paints the authoritative thumb once, without a click or layout movement. */
  function mainFromThumb(cpm) {
    var index = activeThumbIndex(cpm);
    var thumb = cpm.querySelectorAll('.cpm__thumb')[index];
    var main = cpm.querySelector('[data-main-image]');
    var src = thumb && thumb.getAttribute('data-full-src');
    if (!main || !src || deskHidden(cpm) || main.getAttribute('src') === src) return;
    forceThumb(cpm, thumb, index);
  }

  /* Read actual slide geometry, including any gap; hidden strips have no selection. */
  function slideLeft(strip, slide) {
    return strip.scrollLeft + slide.getBoundingClientRect().left - strip.getBoundingClientRect().left - strip.clientLeft;
  }

  function visibleSlideIndex(cpm) {
    var strip = cpm.querySelector('.jc-pdp-swipe');
    var slides = cpm.querySelectorAll('.jc-pdp-slide');
    var index = -1;
    var distance = Infinity;
    var i, next;
    if (!strip || !strip.clientWidth) return -1;
    for (i = 0; i < slides.length; i++) {
      next = Math.abs(slideLeft(strip, slides[i]) - strip.scrollLeft);
      if (next < distance) { distance = next; index = i; }
    }
    return index;
  }

  /* The strip is display:none at 750px and wider. No hidden scroll or saved index. */
  function applyPhone(cpm, index) {
    var strip = cpm.querySelector('.jc-pdp-swipe');
    var slides = cpm.querySelectorAll('.jc-pdp-slide');
    var dots = cpm.querySelectorAll('.jc-pdp-dots > span');
    var left, i, on;
    if (!strip || !strip.clientWidth || !slides[index]) return;
    left = slideLeft(strip, slides[index]);
    if (Math.abs(strip.scrollLeft - left) > 1) strip.scrollTo({ left: left, behavior: 'auto' });
    try { if (strip.jcA11ySync) strip.jcA11ySync(); } catch (e) {}
    for (i = 0; i < dots.length; i++) {
      on = i === index;
      if (dots[i].classList.contains('is-on') !== on) dots[i].classList.toggle('is-on', on);
    }
  }

  function phoneFromDesk(cpm) {
    var index = mapIndex(cpm.querySelectorAll('.cpm__thumb'), cpm.querySelectorAll('.jc-pdp-slide'), activeThumbIndex(cpm));
    if (index >= 0) applyPhone(cpm, index);
  }

  function deskFromPhone(cpm) {
    var thumbs = cpm.querySelectorAll('.cpm__thumb');
    var index = mapIndex(cpm.querySelectorAll('.jc-pdp-slide'), thumbs, visibleSlideIndex(cpm));
    if (index < 0 || index === activeThumbIndex(cpm)) return;
    forceThumb(cpm, thumbs[index], index);
  }

  /* JC-EVO: one delegated listener set per section; callbacks read live DOM, never saved picks. */
  function watchSection(section) {
    var phone, timer, onScroll, onEnd;
    if (section.jcCpmUnwatch || !window.matchMedia) return;
    phone = window.matchMedia('(max-width: 749px)');
    function current() { return sectionNow(section.id) === section; }
    function onLayout(event) {
      var list, i;
      if (!current()) { section.jcCpmUnwatch(); return; }
      clearTimeout(timer);
      list = galleriesIn(section);
      for (i = 0; i < list.length; i++) {
        if (event.matches) phoneFromDesk(list[i]);
        else mainFromThumb(list[i]);
      }
    }
    function settle(strip) {
      var cpm;
      if (!current() || !phone.matches || !strip.clientWidth) return;
      cpm = strip.closest('.cpm');
      if (cpm && section.contains(strip) && section.contains(cpm)) deskFromPhone(cpm);
    }
    onEnd = function (event) {
      var strip = event.target;
      if (strip.classList && strip.classList.contains('jc-pdp-swipe')) settle(strip);
    };
    onScroll = function (event) {
      var strip = event.target;
      if (!strip.classList || !strip.classList.contains('jc-pdp-swipe') || 'onscrollend' in strip) return;
      clearTimeout(timer);
      timer = setTimeout(function () { settle(strip); }, 120);
    };
    section.addEventListener('scrollend', onEnd, true);
    section.addEventListener('scroll', onScroll, true);
    if (phone.addEventListener) phone.addEventListener('change', onLayout);
    else phone.addListener(onLayout);
    section.jcCpmUnwatch = function () {
      clearTimeout(timer);
      section.removeEventListener('scrollend', onEnd, true);
      section.removeEventListener('scroll', onScroll, true);
      if (phone.removeEventListener) phone.removeEventListener('change', onLayout);
      else phone.removeListener(onLayout);
      delete section.jcCpmUnwatch;
    };
  }

  function applyToGallery(cpm, mediaId) {
    var index, thumbs, slides, hits;
    if (!cpm || !mediaId) return;
    index = findIndex(cpm, mediaId);
    if (index < 0) return;
    thumbs = cpm.querySelectorAll('.cpm__thumb');
    slides = cpm.querySelectorAll('.jc-pdp-slide');
    hits = idHits(thumbs, mediaId);
    if (!hits.length) index = mapIndex(slides, thumbs, index);
    if (index < 0) return;
    applyDesk(cpm, index);
    phoneFromDesk(cpm);
  }

  function applyResource(section, resource) {
    var mediaId = mediaIdOf(resource);
    var list, i;
    if (section) watchSection(section);
    if (!mediaId || !section) return;
    remember(section, resource);
    list = galleriesIn(section);
    for (i = 0; i < list.length; i++) applyToGallery(list[i], mediaId);
  }

  function reconcile(sectionId, mine, productId, variantId, resource) {
    var current, picker, selected, use, resourceId, selectedId;
    if (token[sectionId] !== mine) return;
    current = sectionNow(sectionId);
    if (!current) return;
    picker = mainPicker(current);
    if (!picker || picker.getAttribute('data-template-product-match') !== 'true') return;
    if (productId && picker.getAttribute('data-product-id') !== productId) return;
    selected = readSelected(current);
    resourceId = resource && resource.id != null ? String(resource.id) : '';
    selectedId = selected && selected.id != null ? String(selected.id) : '';
    if (resourceId && selectedId && resourceId !== selectedId) return;
    use = resource || selected;
    if (!use || use.id == null) return;
    /* Event variantId is the option's data-variant-id. After the fetch, the picker JSON and
       resource are the variant Horizon actually rendered. They have to agree before a photo
       that differs from variantId is applied. */
    if (variantId && String(use.id) !== String(variantId)) {
      if (!(resourceId && selectedId && resourceId === selectedId)) return;
    }
    applyResource(current, use);
  }

  function onSelect(event) {
    var target = event.target;
    var section, picker, key, mine, variantId, productId, sync, promise;
    if (!target || target.nodeType !== 1 || !target.closest) return;
    if (rejected(target)) return;
    section = target.closest('.shopify-section, dialog');
    if (!section || !section.id || !galleriesIn(section).length) return;
    picker = mainPicker(section);
    if (!picker || target !== picker) return;
    if (picker.getAttribute('data-template-product-match') !== 'true') return;
    key = sectionKey(section);
    token[key] = (token[key] || 0) + 1;
    mine = token[key];
    variantId = event.detail && event.detail.variantId ? String(event.detail.variantId) : '';
    productId = picker.getAttribute('data-product-id') || '';
    sync = lookup(section, variantId);
    promise = event.promise;
    if (promise && promise.then) {
      promise.then(function (result) {
        var resource = result && result.detail && result.detail.resource;
        reconcile(key, mine, productId, variantId, resource || null);
      }, function () {});
    }
    if (sync) applyResource(section, sync);
  }

  function syncInitial(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var sections, i, resource;
    sections = scope.classList && scope.classList.contains('shopify-section') ? [scope] : scope.querySelectorAll('.shopify-section, dialog');
    for (i = 0; i < sections.length; i++) {
      if (!galleriesIn(sections[i]).length) continue;
      watchSection(sections[i]);
      resource = readSelected(sections[i]);
      if (resource) applyResource(sections[i], resource);
    }
  }

  document.addEventListener(EVENT, onSelect);
  document.addEventListener('shopify:section:unload', function (event) {
    if (event.target && event.target.jcCpmUnwatch) event.target.jcCpmUnwatch();
  });
  document.addEventListener('shopify:section:load', function (event) {
    if (event.target) syncInitial(event.target);
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { syncInitial(document); });
  else syncInitial(document);
})();
